import { routeTree } from '@/routeTree.gen';
import { useAuth } from '@/shared/auth';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { PageLoader } from '@widgets/PageLoader';

const router = createRouter({
  context: {
    auth: undefined!,
  },
  defaultPendingComponent: PageLoader,
  defaultPendingMinMs: 0,
  defaultPreload: 'intent',
  routeTree,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export const AppRouter = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return <PageLoader />;
  }

  return <RouterProvider context={{ auth }} router={router} />;
};

AppRouter.displayName = 'AppRouter';
